// extracted by mini-css-extract-plugin
export default {"anchor":"styles_anchor__dk+wn","anchorInner":"styles_anchor-inner__+ODk+"};